var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "info-carteira az-card-bordered",
      class: { "info-carteira--loading": _vm.loading }
    },
    [
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            noData: _vm.noDataState,
            message: _vm.emptyStateMessage,
            minHeight: 245
          }
        },
        [
          _vm.cardData
            ? _c("div", [
                _c("div", { staticClass: "info-carteira__layout" }, [
                  _c("div", { staticClass: "info-carteira__cliente" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "az-text-primary az-size-14 font-medium az-muted mb-4"
                      },
                      [_vm._v(" " + _vm._s(_vm.nomeFormatado) + " ")]
                    ),
                    _c("div", { staticClass: "info-carteira__cliente-box" }, [
                      _c(
                        "div",
                        { staticClass: "info-carteira__cliente-saldo" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "az-text-primary az-size-16 font-semibold"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.cardData.totalInvestido) + " "
                              )
                            ]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "distribuicao-section" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-primary az-size-12 font-semibold"
                          },
                          [_vm._v(" Distribuído nas instituições ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "info-carteira__cliente-lista mt-2" },
                          [
                            _vm._l(_vm.distribuicaoExibida, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "az-text-primary az-size-12 font-semibold az-muted"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.percentual) +
                                        "% " +
                                        _vm._s(item.instituicao)
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm.cardData.distribuicao.length >
                            _vm.limiteDistribuicao
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "BaseButton",
                                      {
                                        staticClass:
                                          "info-carteira__cliente-button",
                                        attrs: { text: "", sm: "" },
                                        on: { click: _vm.alternarVerMais }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.verMaisDistribuicao
                                                ? "Ver menos"
                                                : "Ver mais"
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ])
                  ]),
                  _vm.cardData.temRentabilidade
                    ? _c(
                        "div",
                        { staticClass: "info-carteira__rentabilidade" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "az-text-primary az-size-14 font-medium az-muted mb-4"
                            },
                            [_vm._v(" A rentabilidade total da carteira ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "info-carteira__rentabilidade-lista"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "az-text-primary az-size-14 az-muted"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.cardData.rentabilidade.total) +
                                        "%"
                                    )
                                  ]),
                                  _vm.benchmarkIsTimesLogic
                                    ? _c("span", [
                                        _vm._v(
                                          " do " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " vs " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "az-text-primary az-size-14 az-muted"
                                },
                                [
                                  _c("span", [_vm._v("Ano:")]),
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.coresRentabilidade.ano
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.cardData.rentabilidade.ano
                                          ) +
                                          "% "
                                      )
                                    ]
                                  ),
                                  _vm.benchmarkIsTimesLogic
                                    ? _c("span", [
                                        _vm._v(
                                          " do " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " vs " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "az-text-primary az-size-14 az-muted"
                                },
                                [
                                  _c("span", [_vm._v("Mês:")]),
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.coresRentabilidade.mes
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.cardData.rentabilidade.mes
                                          ) +
                                          "% "
                                      )
                                    ]
                                  ),
                                  _vm.benchmarkIsTimesLogic
                                    ? _c("span", [
                                        _vm._v(
                                          " do " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " vs " + _vm._s(_vm.benchmarkLabel)
                                        )
                                      ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "info-carteira__sem-movimentacoes" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "info-carteira__sem-movimentacoes-texto az-text-primary az-size-14"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.readonly
                                      ? "Não há histórico de ativos cadastrados."
                                      : "Você não cadastrou o histórico de ativos para o seu cliente."
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          !_vm.readonly
                            ? _c(
                                "BaseButton",
                                {
                                  attrs: {
                                    primary: "",
                                    outline: "",
                                    fitContent: ""
                                  },
                                  on: { click: _vm.cadastrarMovimentacao }
                                },
                                [_vm._v(" Cadastrar movimentação ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }